import { FC, useEffect } from "react"

import { applyBrandingSettings } from "../utils"
import { PracticeSettings } from "../types"

const ApplySettings: FC<Props> = ({ settings }) => {
  useEffect(() => {
    applyBrandingSettings(settings)
  }, [settings])

  return null
}

type Props = {
  settings: PracticeSettings
}

export { ApplySettings }
